import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.7405 2.13013C17.137 1.82288 18.3839 3.08262 18.0794 4.4747L18.0436 4.61386L14.4328 16.9674H14.4319C13.9676 18.5536 11.8982 18.8831 10.9554 17.5786L10.8675 17.4467L7.7929 12.4443L2.80996 9.36159C1.36167 8.46536 1.65336 6.2716 3.28848 5.7898L15.6006 2.16594L15.7405 2.13013ZM16.0547 3.34351L15.9529 3.36549L3.64167 6.98935C3.04581 7.16513 2.93605 7.96984 3.46752 8.29876L8.1697 11.2073L12.7238 6.59059L12.771 6.54745C13.0149 6.34559 13.3771 6.35712 13.6076 6.58408C13.838 6.81132 13.8549 7.17379 13.6564 7.42067L13.6141 7.46787L9.04779 12.0976L11.9327 16.7924L11.9987 16.8844C12.3556 17.3076 13.0675 17.1794 13.2324 16.6158L16.8441 4.26311L16.8669 4.15976C16.9365 3.68406 16.5225 3.27494 16.0547 3.34351Z",
			fill: "currentColor"
		})
	})
});
export default SvgSendLine;
